<fsn-tag [size]="size()" [customClass]="ratingClass" icon>{{ text }}</fsn-tag>
